//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    computed: {
        planet () {
            let route = this.$router.options.routes.find(route => route.name === this.$store.getters.currentRoute);
            if (route && route.meta && route.meta.week) {
                return this.$store.getters.getPlanetByWeek(route.meta.week);
            }

            return this.$store.getters.getPlanetByWeek(this.$store.getters.currentWeek);
        }
    },

    mounted () {
        this.$store.commit('hideHTMLElements');
    },

    destroyed () {
        this.$store.commit('showHTMLElements');
    }
};
